import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import axios from 'axios'

const CONTACT_FORM_URL = '/mailing-list/contact'

export class Contact extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            submitted: false,
            loading: false,
            hasUser: this.props.currentUser,
            firstname: this.props.currentUser ? this.props.currentUser.firstname : '',
            lastname: this.props.currentUser ? this.props.currentUser.lastname : '',
            email: this.props.currentUser ? this.props.currentUser.traveler_email : '',
            mssg: '',
            errorMessage: null
        }

        _.bindAll(this,
            'refreshFields',
            'handleChange',
            'getForm',
            'submitContactForm',
            'resetContact'
        )
    }

    componentDidMount() {
        this.refreshFields()
    }
  
    componentDidUpdate(prevProps, prevState) {
        this.refreshFields()
    }

    handleChange(target, value) {
        this.setState({[target]: value})
    }

    resetContact() {
        this.setState({
            submitted: false,
            loading: false,
            mssg: '',
            errorMessage: null
        })
        this.props.updateActiveMenuItem(null)
    }

    refreshFields() {
    // evertime we auto set a field, we have to trigger the class change to move the label up/down
        $('.input-plain input').each(function() {
            var target = $(this)
            target.parent().removeClass('is-focused')
            target.val() ? target.parent().addClass('has-value') : target.parent().removeClass('has-value')
        })
    }

    submitContactForm() {
        this.setState({loading: true})
        let self = this    
        axios.post(CONTACT_FORM_URL, {
            firstname: this.refs.firstname.value ? this.refs.firstname.value : '',
            lastname: this.refs.lastname.value ? this.refs.lastname.value : '',
            email: this.refs.email.value ? this.refs.email.value : '',
            mssg: this.refs.mssg.value ? this.refs.mssg.value : '',
            fromApp: true
        }).then(function(response) {
            if (response.data !== undefined) {   
                // TODO: Fade out sidebar content and show success message     
                console.log(response)
                self.setState({submitted: true, loading: false})
            } else {
                console.log('ERROR: in submitContactForm error')
                console.log(response)
                self.setState({errorMessage: response.data, loading: false})
            }
        }).catch(function(err) {
            console.log('ERROR: in submitBookingRequest error')
            console.log(err)
            self.setState({errorMessage: 'Error submitting request', loading: false})
        })
    }

    getForm() {
        if (!this.state.submitted) {
            return (
                <div className="contact-content">
                    <div className="form-group input-plain">
                        <label htmlFor="firstname">First Name</label>
                        <input
                type="text"
                name="firstname"
                className="form-control input-medium"
                ref="firstname"
                value={this.state.firstname} 
                onChange={() => {this.handleChange('firstname', this.refs.firstname.value)}}/>
                    </div>
                    <div className="form-group input-plain">
                        <label htmlFor="lastname">Last Name</label>
                        <input
                type="text"
                name="lastname"
                className="form-control input-medium"
                ref="lastname"
                value={this.state.lastname} 
                onChange={() => {this.handleChange('lastname', this.refs.lastname.value)}}/>
                    </div>
                    <div className="form-group input-plain">
                        <label htmlFor="email">Email</label>
                        <input
                type="text"
                name="email"
                className="form-control input-medium"
                ref="email"
                value={this.state.email} 
                onChange={() => {this.handleChange('email', this.refs.email.value)}}/>
                    </div>
                    <div className="form-group input-plain">
                        <textarea
                name="mssg"
                className="form-control input-medium"
                ref="mssg"
                placeholder="Message..."
                value={this.state.mssg} 
                onChange={() => {this.handleChange('mssg', this.refs.mssg.value)}}/>
                    </div>
                    <div className="form-group">
                        <button
                type="submit"
                onClick={() => { this.submitContactForm() }}
                className="btn btn-medium">
                  Send
                        </button>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="contact-content">
                    <h1>Thanks!</h1>
                    <div>
            We will follow up with you as soon as possible. 
                    </div>
                </div>
            )
        }
    }

    render() {
        let content = this.getForm()
        let classes = classNames(
            'widget-popup',
            {'active': this.props.activeMenuItem === 'contact'},
            {'disabled': this.state.loading}
        )

        return (
            <div id="sidebar-contact" className={classes}>
                <div className="widget-header-block">
                    <h2>What can we help with?</h2>
                    <i className="icon-close" onClick={() => {this.resetContact()}}/>
                </div>
                <div id="contact-block">
                    { content }
                </div>
            </div>
        )
    }
}